import Image from 'next/image'
import React, { useEffect } from 'react'
import { useMediaQuery } from 'react-responsive'

const ModalWrapper = ({ onClose, children, classNames = '', onlyWrapper, closeBtnStyle = '' }) => {
  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        onClose()
      }
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)
  }, [])

  // Stop propagation for clicks inside the modal to prevent closing when clicking inside
  const stopPropagation = (e) => {
    e.stopPropagation()
  }
  const isMobile = useMediaQuery({ maxWidth: 800 })

  return (
    <div>
      {/* Overlay: Closes modal on click */}
      <div className="fixed w-full h-full bg-black opacity-50 z-[999] top-0 left-0" onClick={onClose} />

      <div className="fixed top-0 left-0 right-0 bottom-0 m-auto z-[9999] flex" onClick={onClose}>
        {onlyWrapper ? (
          <div onClick={stopPropagation}>{children}</div>
        ) : (
          <div
            onClick={stopPropagation} // Prevents modal close when clicking inside the modal
            className={`relative animate-appear modal-background m-auto rounded-2xl flex justify-center flex-col w-[40%] h-[25%] p-[3.5%] ${classNames}`}
          >
            <div
              className={`cursor-pointer absolute top-3 z-[99] right-3 md:right-[-40px] md:invert ${closeBtnStyle}`}
              onClick={() => onClose()}
            >
              <Image
                src={'/assets/common/close-bold.svg'}
                width={isMobile ? 20 : 30}
                height={isMobile ? 20 : 30}
                alt="close"
              />
            </div>
            {children}
          </div>
        )}
      </div>
    </div>
  )
}

export default ModalWrapper
